import { apiRequest } from "./api";

async function postAi(path, token, payload) {
  const response = await apiRequest(path, {
    method: "POST",
    token,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const body = await response.json();

  if (!response.ok) {
    throw new Error(body.error || "AI request failed");
  }
  return body;
}

export function parseSearchIntent(token, payload) {
  return postAi("/api/ai/parse-intent", token, payload);
}

export function generateProposalOutline(token, payload) {
  return postAi("/api/ai/proposal-outline", token, payload);
}

export function generateProposalSection(token, payload) {
  return postAi("/api/ai/proposal-section", token, payload);
}

export function assessOpportunity(token, { opportunity }) {
  const boundedOpportunity = {
    noticeId: opportunity?.noticeId,
    notice_id: opportunity?.notice_id,
    title: opportunity?.title,
    fullParentPathName: opportunity?.fullParentPathName,
    department: opportunity?.department,
    agency: opportunity?.agency,
    naicsCode: opportunity?.naicsCode,
    typeOfSetAsideDescription: opportunity?.typeOfSetAsideDescription,
    typeOfSetAside: opportunity?.typeOfSetAside,
    award_amount: opportunity?.award_amount,
    awardAmount: opportunity?.awardAmount,
    description: typeof opportunity?.description === "string"
      ? opportunity.description.slice(0, 800)
      : undefined,
  };
  return postAi("/api/ai/opportunity-assessment", token, {
    opportunity: boundedOpportunity,
  });
}

export function sendAssistantMessage(token, payload) {
  return postAi("/api/ai/assistant", token, payload);
}
